var map = {
	"./AboutView": 833,
	"./AboutView.vue": 833,
	"./ChinaPriceList": 1763,
	"./ChinaPriceList.vue": 1763,
	"./CollectionCertificate": 5083,
	"./CollectionCertificate.vue": 5083,
	"./ContactInformation": 7785,
	"./ContactInformation.vue": 7785,
	"./ContactMobile": 4004,
	"./ContactMobile.vue": 4004,
	"./HdrData": 4782,
	"./HdrData.vue": 4782,
	"./HomeView": 6645,
	"./HomeView.vue": 6645,
	"./InsectBreed": 4998,
	"./InsectBreed.vue": 4998,
	"./InsectCraft": 3645,
	"./InsectCraft.vue": 3645,
	"./InsectCraftList": 3651,
	"./InsectCraftList.vue": 3651,
	"./InsectList": 9445,
	"./InsectList.vue": 9445,
	"./InsectMuseum": 8170,
	"./InsectMuseum.vue": 8170,
	"./InsectSpecimen": 4813,
	"./InsectSpecimen.vue": 4813,
	"./InsertData": 2703,
	"./InsertData.vue": 2703,
	"./MuseumDesign": 545,
	"./MuseumDesign.vue": 545,
	"./OrderInfo": 8295,
	"./OrderInfo.vue": 8295,
	"./PlantMusum": 4512,
	"./PlantMusum.vue": 4512,
	"./PriceList": 2376,
	"./PriceList.vue": 2376,
	"./PriceListWang": 7882,
	"./PriceListWang.vue": 7882,
	"./ScienceResearch": 2221,
	"./ScienceResearch.vue": 2221,
	"./SearchSystem": 3191,
	"./SearchSystem.vue": 3191,
	"./SearchSystemAmphibious": 8347,
	"./SearchSystemAmphibious.vue": 8347,
	"./SearchSystemAnimal": 2569,
	"./SearchSystemAnimal.vue": 2569,
	"./SearchSystemBird": 6619,
	"./SearchSystemBird.vue": 6619,
	"./SearchSystemFish": 1150,
	"./SearchSystemFish.vue": 1150,
	"./SearchSystemPlant": 5984,
	"./SearchSystemPlant.vue": 5984,
	"./SearchSystemReptiles": 2120,
	"./SearchSystemReptiles.vue": 2120,
	"./ShoppingList": 4796,
	"./ShoppingList.vue": 4796,
	"./ShoppingListButterfly": 915,
	"./ShoppingListButterfly.vue": 915,
	"./ThreeList": 2408,
	"./ThreeList.vue": 2408,
	"./specimenMuseum": 3474,
	"./specimenMuseum.vue": 3474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6768;